<template>
  <div class="selectionMenu">
    <el-dialog title="功能选择" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <div class="border">
        <ul class="border-ul">
          <li v-for="(item,index) in dataList" :key="index" @click="goUrl(item)">{{item.title}}</li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    dataList: {
      type: Array,
      default() {
        return []
      }
    },
    isShow: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
    return {
      dialogVisible: false
    };
  },
  created() {
  },
  methods: {
    // 关闭弹出框
    handleClose(done) {
      done();
    },
    // 跳转
    goUrl(item) {
      if (typeof item.url !== 'string') return;
      let baseUrl = window.location;
      nw.Window.open(`${baseUrl.origin}${baseUrl.pathname}#${item.url}?title=${item.title}&status=${item.status}`, { fullscreen: true, frame: true }, () => { });
      // nw.Window.open('http://192.168.0.126:8080/#/exitFactory', {}, () => { });
    }
  },
  watch: {
    isShow() {
      this.dialogVisible = !this.dialogVisible
    }
  }
};
</script>
<style lang="less" scoped>
.border {
  width: 100%;
  height: 500px;
  overflow-y: scroll;
  .border-ul {
    li {
      width: 120px;
      height: 90px;
      line-height: 90px;
      text-align: center;
      margin: 10px;
      background: red;
      display: inline-block;
      font-size: 18px;
      letter-spacing: 3px;
      color: #ffffff;
      float: left;
      cursor: pointer;
    }
  }
}
</style>